var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvancebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    width: 4,
    height: 18,
    rx: 2,
    fill: "#E6165C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 6,
    width: 4,
    height: 12,
    rx: 2,
    fill: "#E6165C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 12,
    width: 4,
    height: 6,
    rx: 2,
    fill: "#E6165C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancebar);
export default __webpack_public_path__ + "static/media/advancebar.6832185be72cc652b1f10717ca86ba67.svg";
export { ForwardRef as ReactComponent };